export default {
  index: {
    path: '/',
    title: '首页',
  },
  login: {
    path: '/login',
    title: '登录',
  },
  register: {
    path: '/register',
    title: '注册',
  },
  reset: {
    path: '/reset',
    title: '忘记密码',
  },
  terms: {
    path: '/terms',
    title: '免责声明',
  },
  accountThaw: {
    path: '/accountThaw',
    title: '账号解冻',
  },
  wxBind: {
    path: '/wxBind',
    title: '登录微信绑定',
  },
  message: {
    path: '/message',
    title: '登录微信绑定',
  },
  other: {
    // 联系技术
    connectTech: 'http://q.url.cn/abnhLo?_type=wpa&qidian=true',
    // 帮助中心
    helpCenter: 'https://123.weihudashi.com/',
    // 软件下载
    downloadApp: 'https://www.weihudashi.com/download.html',
    // 插件下载
    downloadPlugin:
      // "http://yzhloss.oss-cn-hangzhou.aliyuncs.com/RCweb/InitPlugin.exe"
      'https://yzhloss.oss-cn-hangzhou.aliyuncs.com/RCweb/InitPlugin7.0.exe',
  },
  home: {
    path: '/home',
    children: {
      barManager: {
        path: '/home/barManager',
        title: '网吧管理',
        children: {
          index: {
            path: '/home/barManager/index',
            children: {
              allBar: {
                path: '/home/barManager/index/barAll',
                title: '全部网吧',
              },
              recentRemote: {
                path: '/home/barManager/index/recentRemote',
                title: '最近远程',
              },
              serverOfflineBar: {
                path: '/home/barManager/index/serverOfflineBar',
                title: '服务器离线的网吧',
              },
              serverLabelManage: {
                path: '/home/barManager/index/serverLabelManage',
                title: '服务器标签管理',
              },
              remoteRecord: {
                path: '/home/barManager/index/remoteRecord',
                title: '远程协助记录',
              },
              groupBar: {
                path: '/home/barManager/index/groupBar',
              },
              searchBar: {
                path: '/home/barManager/index/searchBar',
                title: '搜索结果',
              },
              barDetails: {
                path: '/home/barManager/index/barDetails',
                title: '网吧内容',
              },
            },
          },
        },
      },
      staffManage: {
        path: '/home/staffManage',
        title: '员工管理',
      },
      messageBoard: {
        path: '/home/messageBoard',
        title: '网吧留言板',
        children: {
          barMessage: {
            path: '/home/messageBoard/barMessage',
            title: '全部留言',
          },
        },
      },
      accountSafe: {
        path: '/home/accountSafe',
        title: '账号安全',
      },
      operationLog: {
        path: '/home/operationLog',
        title: '操作日志',
      },
      download: {
        path: '/home/download',
        title: '安全中心客户端',
      },
      debugModel: {
        path: '/home/debugmodel',
        title: '调试模式',
      },
      securityCenter: {
        path: '/home/securityCenter',
        title: '安全中心',
        children: {
          index: {
            path: '/home/securityCenter/index',
            // children: {
            //     safetyRules: {
            //         path: "/home/securityCenter/index/safetyRules",
            //         title: "我的安全规则",
            //     },
            //     shareRules: {
            //         path: "/home/securityCenter/index/shareRules",
            //         title: "共享规则库",
            //     },
            //     barManageSecurityGroup: {
            //         path: "/home/securityCenter/index/barManageSecurityGroup",
            //         title: "网吧管理与安全组",
            //     },
            // },
            children: [
              {
                path: '/home/securityCenter/index/barList',
                title: '安全中心网吧列表',
                id: 'v-step-1',
              },
              {
                path: '/home/securityCenter/index/barManageSecurityGroup',
                title: '规则分组管理',
                id: 'v-step-3',
              },
              {
                path: '/home/securityCenter/index/safetyRules',
                title: '我的安全规则',
                id: 'v-step-4',
              },
              {
                path: '/home/securityCenter/index/shareRules',
                title: '规则大厅',
                id: 'v-step-2',
              },
              {
                path: '/home/securityCenter/index/dll',
                title: 'DLL注入',
              },
              {
                path: '/home/securityCenter/index/powerChannel',
                title: '开机通道',
              },
              {
                path: '/home/securityCenter/index/download',
                title: '安全中心客户端下载',
                id: 'v-step-0',
              },
            ],
          },
        },
      },
      aloneClient: {
        path: '/home/securityCenter',
        title: '独立版客户端管理',
        children: {
          index: {
            path: '/home/securityCenter/index',
            // children: {
            //     safetyRules: {
            //         path: "/home/securityCenter/index/safetyRules",
            //         title: "我的安全规则",
            //     },
            //     shareRules: {
            //         path: "/home/securityCenter/index/shareRules",
            //         title: "共享规则库",
            //     },
            //     barManageSecurityGroup: {
            //         path: "/home/securityCenter/index/barManageSecurityGroup",
            //         title: "网吧管理与安全组",
            //     },
            // },
            children: [
              {
                path: '/home/securityCenter/index/barList',
                title: '安全中心网吧列表',
              },
              {
                path: '/home/securityCenter/index/client',
                title: '客户端管理',
              },
              {
                path: '/home/download',
                title: '安全中心客户端',
              },
              // {
              //     path: "/home/clientDetail/index/client",
              //     title: "客户端详细信息",
              // },
              // {
              //   path: '/home/securityCenter/index/clientHardware',
              //   title: '客户端详情',
              // },
              // {
              //     path: "/home/securityCenter/index/clientSoftware",
              //     title: "客户端软件",
              // },
            ],
          },
        },
      },

      threeTierMission: {
        path: '/home/threeTierMission',
        title: '三层任务',
      },
      fileManage: {
        path: '/home/fileManage',
        title: '文件管理',
      },
      userInfo: {
        path: '/home/userInfo',
        title: '用户信息',
      },
      OEMInfo: {
        path: '/home/OEMInfo',
        title: 'OEM信息',
      },
      VIPInfo: {
        path: '/home/VIPInfo',
        title: 'VIP信息',
      },
    },
  },
};
